import { render, staticRenderFns } from "./CampaignStatus.vue?vue&type=template&id=e18edbb4&"
import script from "./CampaignStatus.vue?vue&type=script&lang=ts&"
export * from "./CampaignStatus.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports